module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "z-input-autocomplete",
    class: {
      inline: _vm.inline
    }
  }, [_c('div', {
    staticClass: "z-input-autocomplete-container"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$props.validate),
      expression: "$props.validate"
    }],
    ref: "input",
    attrs: {
      "light": _vm.$props.light,
      "name": _vm.name,
      "id": _vm.$props.id,
      "label": _vm.$props.label,
      "error": _vm.inputError,
      "mask": _vm.$props.mask,
      "disabled": _vm.disabled || _vm.isSelected,
      "loading": _vm.loading,
      "inline": _vm.inline,
      "placeholder": _vm.$props.placeholder,
      "autocomplete": "off",
      "data-vv-as": ' ',
      "dirty": _vm.isDirty,
      "no-resize": _vm.$props.noResize
    },
    on: {
      "focus": _vm.onFocus,
      "update:dirty": function($event) {
        _vm.isDirty = $event
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "list-container"
  }, [_c('div', {
    ref: "list",
    staticClass: "list can-scroll"
  }, _vm._l((_vm.findResult), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, $event, true)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item[_vm.listProperty]))])])
  }))])]), (!_vm.$props.disabled) ? _c('div', {
    staticClass: "button-bar"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelected),
      expression: "isSelected"
    }],
    staticClass: "btn",
    class: {
      light: _vm.$props.light
    },
    on: {
      "click": function($event) {
        _vm.onClear(true)
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": ['fa', 'times']
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.showSaveBtn && _vm.isSelected),
      expression: "$props.showSaveBtn && isSelected"
    }],
    staticClass: "btn",
    class: {
      light: _vm.$props.light
    },
    on: {
      "click": function($event) {
        _vm.onSave(true)
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": ['fa', 'check']
    }
  })], 1)]) : _vm._e()], 1), (_vm.$props.required) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelected),
      expression: "isSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "visibility": "hidden",
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": "isSelected",
      "data-vv-as": " "
    },
    domProps: {
      "checked": Array.isArray(_vm.isSelected) ? _vm._i(_vm.isSelected, null) > -1 : (_vm.isSelected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelected = $$c
        }
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc56b3a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInputAutocomplete.vue
// module id = 1092
// module chunks = 0